import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";

/** Admin-only (#140): record switching the Anonym-Ansicht on or off. */
export function useLogHideModeSwitch(): UseMutationResult<void, Error, boolean> {
  const client = useVidarioClient();
  return useMutation({ mutationFn: (turnedOn: boolean) => client.logHideModeSwitch(turnedOn) });
}

export interface CandidateOpenedInput {
  candidateId: string;
  action: "source_profile_opened" | "attachment_opened";
  kind: "linkedin" | "xing" | "cv" | "photo";
}

/** Admin-only (#140): record opening a profile or attachment while hiding. */
export function useLogCandidateOpened(): UseMutationResult<void, Error, CandidateOpenedInput> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CandidateOpenedInput) => client.logCandidateOpened(input),
    // The new entry shows in the candidate's Aktivität list.
    onSettled: (_data, _err, input) =>
      void qc.invalidateQueries({ queryKey: ["candidates", input.candidateId, "log"] }),
  });
}
